<script setup lang="ts">
import { BlockHeaderTile } from '~/lib/services/content/content.blocks.dtos'

const props = defineProps<{
  block: BlockHeaderTile
}>()

const firstWord = props.block.title.split(' ')[0]
const restTitle = props.block.title.split(' ').slice(1).join(' ')
const isMobile = inject<Ref<boolean>>('isMobile')
</script>

<template>
  <div class="flex w-full flex-col lg:flex-row">
    <section class="flex flex-col justify-center gap-8 px-8 py-12 lg:w-1/2 lg:px-[104px]">
      <header class="flex flex-col gap-2 lg:w-[512px]">
        <h1
          class="text-5xl font-bold leading-[54px] tracking-[-0.15px] lg:text-[80px] lg:leading-[84px]"
        >
          <span class="relative">
            <span class="absolute bottom-2 left-2 h-6 w-full bg-mcd-main lg:h-[42px]"></span>
            <span class="relative">{{ firstWord }}</span>
          </span>

          {{ restTitle }}
        </h1>
        <p class="text-sm leading-4 tracking-[-0.15px] lg:text-lg lg:leading-6">
          {{ block.content }}
        </p>
      </header>

      <footer
        v-if="block.primaryBtn || block.secondaryBtn"
        class="grid grid-cols-2 gap-4 lg:flex lg:items-start"
      >
        <SimpleLink v-if="block.primaryBtn" :link="block.primaryBtn">
          <McdButton class="h-10 w-full bg-mcd-black text-white lg:w-40">
            {{ block.primaryBtn?.title }}
          </McdButton>
        </SimpleLink>
        <SimpleLink v-if="block.secondaryBtn" :link="block.secondaryBtn">
          <McdButton class="h-10 w-full lg:w-40" is-secondary>
            {{ block.secondaryBtn?.title }}
          </McdButton>
        </SimpleLink>
      </footer>
    </section>

    <aside v-if="block.imageMobile && block.imageDesktop" class="h-60 sm:h-[480px] lg:w-1/2">
      <img
        class="h-full w-full object-fill"
        :src="isMobile ? block.imageMobile.url : block.imageDesktop.url"
        :alt="
          (isMobile ? block.imageMobile.alternativeText : block.imageDesktop.alternativeText) ||
          undefined
        "
      />
    </aside>
  </div>
</template>
